var DualRowPackageWithDifferentPadsData = require('./dualRowPackageWithDifferentPadsData.js');
var lib_core = require("lib-core");
var ComponentAttribute = require('./componentAttribute.js');
var lib_geometry = require("lib-geometry");

var ChipArrayTwoSideConvexData = function(position, angle, init) {
    DualRowPackageWithDifferentPadsData.apply(this, arguments);

    //component family if any
    this.componentFamily = this.value("componentFamily", true);
    this.nonTransformedSegmentedGeometry.addTrigger(this.componentFamily);
};

lib_core.inherit(ChipArrayTwoSideConvexData, DualRowPackageWithDifferentPadsData);
lib_core.JsonParser.registerClass(ChipArrayTwoSideConvexData, "ChipArrayTwoSideConvexData");

module.exports = ChipArrayTwoSideConvexData;

ChipArrayTwoSideConvexData.prototype.getPads = function(absolutePositions) {
    var self = this;
    var pads = [];

    //reset component
    self.component.reset();

    //Note: Pad should be calculated in anti-clockwise direction [left, down, right, up] for quad packages and [left and right] for rest of the packages.
    //The order is important to apply proper pad name from the generated namelist. Do not change the order otherwise pad's name would be incorrect.
    self.updateComponentCalculator(self.horizontalLeadToLeadSpanMin(), self.horizontalLeadToLeadSpanMax());

    var i, nRow = self.component.padsPerSide[0],
        hPitch = self.component.C,
        vPitch = self.verticalPinPitch(),
        motif = self.getMotif(),
        normalPadWidth = motif.getTopCopper().width(),
        normalPadHeight = motif.getTopCopper().height(),
        normalRx = motif.getTopCopper().rx(), //used to restore roundness of normal pad
        normalRy = motif.getTopCopper().ry();

    for(i = 0; i < 2 * nRow; i++) {
        var col = Math.floor(i / nRow);
        var row = i % nRow;
        if (col % 2 == 1) row = nRow - 1 - row; // in odd columns change order from bottom to top

        //use odd pad for 4 corners if odd pad size is not 0 or undefined
        //if max exist
        if ((i == 0 || i == nRow - 1 || i == nRow || i == 2 * nRow - 1) && self.oddPadHeightMax()) {
            //if odd pad size is different than normal pad size recalculate motif
            if (self.oddPadHeightMax() !== self.padHeightMax() || self.oddPadHeightMin() !== self.padHeightMin()) {
                self.component.padHeightMax = self.oddPadHeightMax();
                self.component.padHeightMin = self.oddPadHeightMin();

                self.updateComponentCalculator(undefined, undefined, false);
                motif = self.getMotif();
            } else {
                //use normal pad for others
                motif.padstack().topCopper().width(normalPadWidth);
                motif.padstack().topCopper().height(normalPadHeight);
                motif.padstack().topCopper().rx(normalRx);
                motif.padstack().topCopper().ry(normalRy);
            }
        } else {
            //use normal pad for others
            motif.padstack().topCopper().width(normalPadWidth);
            motif.padstack().topCopper().height(normalPadHeight);
            motif.padstack().topCopper().rx(normalRx);
            motif.padstack().topCopper().ry(normalRy);
        }

        var pad = motif.clone();
        pad.move(new lib_geometry.Coord((-0.5 + col) * hPitch, ((nRow - 1) / 2 - row) * vPitch));

        pads.push(pad);
    }

    self.updatePads(pads, absolutePositions);
    return pads;
};
